import { useState, useEffect } from 'react';
import { getJobCampaignAnalytics, IAutomatedEmailCampaignListPayload } from 'wisestep-api';

export interface IResultSetInfo {
  count: number;
  delivery_status: string;
  campaign_code: string;
}

interface IJobCampaignAnalytics {
  count: number;
  resultSet: IResultSetInfo[];
}

const useGetJobCampaignAnalytics = (payload: IAutomatedEmailCampaignListPayload) => {
  const [analytics, setAnalytics] = useState<IJobCampaignAnalytics>({} as IJobCampaignAnalytics);

  useEffect(() => {
    (async () => {
      try {
        const res = await getJobCampaignAnalytics(payload);
        setAnalytics(res?.data);
      } catch (e) {
        console.error('Failed to load the Job Data', e);
      }
    })();
  }, [payload]);

  return { analytics };
};

export default useGetJobCampaignAnalytics;
